export default function AppSection() {
  return (
    <section id="app" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="rounded-3xl overflow-hidden relative bg-gradient-to-br from-primary-400 via-primary-500 to-primary-700 p-8 md:p-14">
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-black text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                APP下载
              </h2>
              <p className="text-white/80 mt-3 text-sm md:text-base leading-relaxed max-w-md mx-auto lg:mx-0">
                下载甜柚漫画APP，享受更流畅的移动阅读体验。离线缓存、夜间模式、个性化推荐，随时随地甜蜜阅读。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-primary-600 font-bold text-sm whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
                >
                  <i className="ri-apple-fill text-xl"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
                >
                  <i className="ri-android-fill text-xl"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="shrink-0">
              <div className="w-48 h-48 bg-white/15 backdrop-blur-sm rounded-3xl border border-white/20 flex flex-col items-center justify-center gap-3">
                <i className="ri-qr-code-line text-white text-5xl"></i>
                <span className="text-white/70 text-xs">扫码下载</span>
              </div>
            </div>
          </div>
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-primary-300/20 blur-3xl"></div>
          <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full bg-accent-400/20 blur-3xl"></div>
        </div>
      </div>
    </section>
  );
}